import { Game, FreeSpinReelTransitionController, GameAvailableWinDisplay, GameBackground, GameController, GameControlPanel, GameDialogController, GameDialogManager, GameFreeSpinsOverlay, GameLoaderDialog, GameMessageBarData, GameMiniPayTable, GameModel, GamePayTable, GamePayTableCell, GameReel, GameReelController, GameReels, GameSoundController, GameSpinsRemaining, GameStakeSelector, GameSummary, GameTest, GameTicket, GameWinDisplay, GameMessageBar, Main, GameCoinWinOverlay } from "@lib/js-slingo-pawnshop-core/dist";
import { GameTicketSymbol } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameTicketSymbol";
import { AppController } from "@lib/titan2-slingo/dist/game/controller/AppController";
import { Navigation } from "@lib/titan2-slingo/dist/game/view/abstract/display/Navigation";
import { Options } from "@lib/titan2-slingo/dist/game/view/abstract/display/Options";
import { ResponsibleGamingOptionType } from "@lib/titan2/dist/api/common/model/enum/ResponsibleGamingOptionType";
import { AppData } from "@lib/titan2/dist/game/AppData";
import { OrientationController } from "@lib/titan2/dist/game/controller/OrientationController";
import { SettingsController } from "@lib/titan2/dist/game/controller/SettingsController";
import { GameConfig } from "@lib/titan2/dist/game/model/data/GameConfig";
import { OrientationType } from "@lib/titan2/dist/game/renderer/constant/RendererConstants";
import { Viewport } from "@lib/titan2/dist/game/renderer/properties/Viewport";
import { DemoPlay } from "@lib/titan2/dist/game/view/display/DemoPlay";
import { DetailedGameHistory } from "@lib/titan2/dist/game/view/display/DetailedGameHistory";
import { Preloader } from "@lib/titan2/dist/game/view/display/Preloader";
import { SGDSignposting } from "@lib/titan2/dist/game/view/display/SGDSignposting";
import { DetailedGameHistoryPropertiesLandscape, DetailedGameHistoryPropertiesPortrait } from "@lib/titan2/dist/game/view/properties/AbstractDetailedGameHistoryProperties";
import { AbstractFreeRoundsInfoBannerProperties, FreeRoundsInfoBannerLocation } from "@lib/titan2/dist/game/view/properties/AbstractFreeRoundsInfoBannerProperties";
import { SGDSignpostingLandscapeProperties, SGDSignpostingPortraitProperties } from "@lib/titan2/dist/game/view/properties/SGDSignpostingProperties";
import * as PIXI from "pixi.js";
import { FontMapLandscape } from "../font/FontMapLandscape";
import { AvailableWinDisplayLandscapeProperties } from "../view/properties/landscape/AvailableWinDisplayLandscapeProperties";
import { ControlPanelLandscapeProperties, OptionsLandscapeProperties, StakeSelectorLandscapeProperties } from "../view/properties/landscape/ControlPanelLandscapeProperties";
import { DemoPlayLandscapeProperties } from "../view/properties/landscape/DemoPlayLandscapeProperties";
import { DialogManagerLandscapeProperties } from "../view/properties/landscape/DialogManagerLandscapeProperties";
import { FreeSpinsOverlayLandscapeProperties } from "../view/properties/landscape/FreeSpinsOverlayLandscapeProperties";
import { FullHouseLandscapeProperties } from "../view/properties/landscape/FullHouseLandscapeProperties";
import { GameBackgroundLandscapeProperties } from "../view/properties/landscape/GameBackgroundLandscapeProperties";
import { GameSummaryLandscapeProperties } from "../view/properties/landscape/GameSummaryLandscapeProperties";
import { LoaderLandscapeProperties, PreloaderLandscapeProperties } from "../view/properties/landscape/LoaderLandscapeProperties";
import { MessageBarLandscapeProperties } from "../view/properties/landscape/MessageBarLandscapeProperties";
import { NavigationLandscapeProperties } from "../view/properties/landscape/NavigationLandscapeProperties";
import { PayTableLandscapeProperties } from "../view/properties/landscape/PayTableLandscapeProperties";
import { ReelLandscapeProperties } from "../view/properties/landscape/ReelLandscapeProperties";
import { ReelsLandscapeProperties } from "../view/properties/landscape/ReelsLandscapeProperties";
import { SlingoAnimationLandscapeProperties } from "../view/properties/landscape/SlingoAnimationLandscapeProperties";
import { SpinsRemainingLandscapeProperties } from "../view/properties/landscape/SpinsRemainingLandscapeProperties";
import { TestDisplayLandscapeProperties } from "../view/properties/landscape/TestDisplayLandscapeProperties";
import { TicketLandscapeProperties } from "../view/properties/landscape/TicketLandscapeProperties";
import { TicketSymbolLandscapeProperties } from "../view/properties/landscape/TicketSymbolLandscapeProperties";
import { WinDisplayLandscapeProperties } from "../view/properties/landscape/WinDisplayLandscapeProperties";
import { AvailableWinDisplayPortraitProperties } from "../view/properties/portrait/AvailableWinDisplayPortraitProperties";
import { ControlPanelPortraitProperties, OptionsPortraitProperties, StakeSelectorPortraitProperties } from "../view/properties/portrait/ControlPanelPortraitProperties";
import { DialogManagerPortraitProperties } from "../view/properties/portrait/DialogManagerPortraitProperties";
import { FreeSpinsOverlayPortraitProperties } from "../view/properties/portrait/FreeSpinsOverlayPortraitProperties";
import { FullHousePortraitProperties } from "../view/properties/portrait/FullHousePortraitProperties";
import { GameBackgroundPortraitProperties } from "../view/properties/portrait/GameBackgroundPortraitProperties";
import { GameSummaryPortraitProperties } from "../view/properties/portrait/GameSummaryPortraitProperties";
import { LoaderPortraitProperties, PreloaderPortraitProperties } from "../view/properties/portrait/LoaderPortraitProperties";
import { MessageBarPortraitProperties } from "../view/properties/portrait/MessageBarPortraitProperties";
import { MiniPayTablePortraitProperties } from "../view/properties/portrait/MiniPayTablePortraitProperties";
import { NavigationPortraitProperties } from "../view/properties/portrait/NavigationPortraitProperties";
import { PayTablePortraitProperties } from "../view/properties/portrait/PayTablePortraitProperties";
import { ReelsPortraitProperties } from "../view/properties/portrait/ReelsPortraitProperties";
import { SlingoAnimationPortraitProperties } from "../view/properties/portrait/SlingoAnimationPortraitProperties";
import { SpinsRemainingPortraitProperties } from "../view/properties/portrait/SpinsRemainingPortraitProperties";
import { TestDisplayPortraitProperties } from "../view/properties/portrait/TestDisplayPortraitProperties";
import { TicketPortraitProperties } from "../view/properties/portrait/TicketPortraitProperties";
import { WinDisplayPortraitProperties } from "../view/properties/portrait/WinDisplayPortraitProperties";
import { ScatterWinLandscapeProperties } from "../view/properties/landscape/ScatterWinLandscapeProperties";
import { GameScatterWin } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameScatterWin";
import { ArcadeWheelLandscapeProperties } from "../view/properties/landscape/ArcadeWheelLandscapeProperties";
import { ArcadeWheelPortraitProperties } from "../view/properties/portrait/ArcadeWheelPortraitProperties";
import { CoinWinOverlayLandscapeProperties } from "../view/properties/landscape/CoinWinOverlayLandscapeProperties";
import { CoinWinOverlayPortraitProperties } from "../view/properties/portrait/CoinWinOverlayPortraitProperties";
import { ScatterWinPortraitProperties } from "../view/properties/portrait/ScatterWinPortraitProperties";
import { GameFullHouse } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameFullHouse";
import { GameSlingoAnimation } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameSlingoAnimation";
import { FeatureTransitionController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureTransitionController";
import { FeatureGreenFishController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureGreenFishController";
import { FeatureFishFood } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/fishfood/FeatureFishFood";
import { FeatureFishFoodController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureFishFoodController";
import { FeatureGoldFishController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureGoldFishController";
import { FeatureGoldFish } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/goldfish/FeatureGoldFish";
import { FeatureRedFishController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureRedFishController";
import { FeatureRedFish } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/redfish/FeatureRedFish";
import { FeaturePurpleFishController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeaturePurpleFishController";
import { FeaturePurpleFish } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/purplefish/FeaturePurpleFish";
import { FeatureGreenFishLandscapeProperties } from "../view/properties/landscape/features/greenfish/FeatureGreenFishLandscapeProperties";
import { FeatureGreenFishPortraitProperties } from "../view/properties/portrait/features/greenfish/FeatureGreenFishPortraitProperties";
import { FeatureGreenFish } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/greenfish/FeatureGreenFish";
import { GameMainTransition } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameMainTransition";
import { GameMainTransitionLandscapeProperties } from "../view/properties/landscape/GameMainTransitionLandscapeProperties";
import { GameMainTransitionPortraitProperties } from "../view/properties/portrait/GameMainTransitionPortraitProperties";
import { FeatureSelector } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/features/FeatureSelector";
import { FeatureSelectorLandscapeProperties } from "../view/properties/landscape/features/FeatureSelectorLandscapeProperties";
import { FeatureSelectorPortraitProperties } from "../view/properties/portrait/features/FeatureSelectorPortraitProperties";
import { FeatureSelectorController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/FeatureSelectorController";
import { FeatureRedFishLandscapeProperties } from "../view/properties/landscape/features/redfish/FeatureRedFishLandscapeProperties";
import { FeatureRedFishPortraitProperties } from "../view/properties/portrait/features/redfish/FeatureRedFishPortraitProperties";
import { FeatureGoldFishLandscapeProperties } from "../view/properties/landscape/features/goldfish/FeatureGoldFishLandscapeProperties";
import { FeatureGoldFishPortraitProperties } from "../view/properties/portrait/features/goldfish/FeatureGoldFishPortraitProperties";
import { FeatureFishFoodLandscapeProperties } from "../view/properties/landscape/features/fishfood/FeatureFishFoodLandscapeProperties";
import { FeatureFishFoodPortraitProperties } from "../view/properties/portrait/features/fishfood/FeatureFishFoodPortraitProperties";
import { FeaturePurpleFishLandscapeProperties } from "../view/properties/landscape/features/purplefish/FeaturePurpleFishLandscapeProperties";
import { FeaturePurpleFishPortraitProperties } from "../view/properties/portrait/features/purplefish/FeaturePurpleFishPortraitProperties";
import { GameFreeSpinsCounter } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameFreeSpinsCounter";
import { FreeSpinsCounterPortraitProperties } from "../view/properties/portrait/FreeSpinsCounterPortraitProperties";
import { FreeSpinsCounterLandscapeProperties } from "../view/properties/landscape/FreeSpinsCounterLandscapeProperties";
import { GameBigWin } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameBigWin";
import { BigWinLandscapeProperties } from "../view/properties/landscape/BigWinLandscapeProperties";
import { BigWinPortraitProperties } from "../view/properties/portrait/BigWinPortraitProperties";
import { FeatureIntro } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameFeatureIntro";
import { FeatureIntroLandscapeProperties } from "../view/properties/landscape/FeatureIntroLandscapeProperties";
import { FeatureIntroPortraitProperties } from "../view/properties/portrait/FeatureIntroPortraitProperties";
import { BonusHelp } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/BonusHelp";
import { BonusHelpLandscapeProperties } from "../view/properties/landscape/BonusHelpLandscapeProperties";
import { BonusHelpPortraitProperties } from "../view/properties/portrait/BonusHelpPortraitProperties";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { GameArcardWheel } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/GameArcadeWheel";
import { FreeSpinsRainbowOverlay } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/display/FreeSpinsRainbowOverlay";
import { FreeSpinsRainbowOverlayLandscapeProperties } from "../view/properties/landscape/FreeSpinsRainbowOverlayLandscapeProperties";
import { FreeSpinsRainbowOverlayPortraitProperties } from "../view/properties/portrait/FreeSpinsRainbowOverlayPortraitProperties";
import { GameSoundLiftController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundLiftController";
import { GameSoundLadyMeowController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundLadyMeowController";
import { GameSoundJaspurrsCupsController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundJaspurrsCupsController";
import { GameSoundHungryHenryController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundHungryHenryController";
import { GameSoundTailTotesController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundTailTotesController";
import { GameSoundClawpawtraController } from "@lib/js-slingo-pawnshop-core/dist/game/controller/audio/GameSoundClawpawtraController";
/**
 * Factory.ts
 */
export class Factory {
    constructor() {
        this.createFontMap();
        this.createModel();
    }
    createMiniPayTable() {
        throw new Error("Method not implemented.");
    }
    createPayTableManager() {
        throw new Error("Method not implemented.");
    }
    createFontMap() {
        return new FontMapLandscape();
    }
    createBitmapFonts() {
    }
    createModel() {
        this.model = new GameModel();
        this.model.setAutoDabInterval(450);
        this.model.setCompleteInterval(0);
        this.model.setUsePurchaseSpinTotal(true);
        this.model.setCollectAvailable(true);
        this.model.setBonusBalanceEnabled(true);
        this.model.setAutoSpin(true);
        this.model.setPriceThreshold(10);
        this.model.addOption(ResponsibleGamingOptionType.EXTRA_SPIN, [0, 2, 4, 6, 8]);
        this.model.addOption(ResponsibleGamingOptionType.SPIN_PRICE, [1, 2, 5, 10, 25]);
        this.model.addOption(ResponsibleGamingOptionType.SINGLE_GAME_STAKE, [2, 5, 10, 20, 50]);
        this.model.addOption(ResponsibleGamingOptionType.MAXIMUM_LOSS, [10, 20, 30, 40, 50]);
    }
    createPreloader() {
        return new Preloader(this, new PreloaderLandscapeProperties(), new PreloaderPortraitProperties());
    }
    createLoader() {
        const version = `${AppData.RELEASE_VERSION}`;
        const loader = new GameLoaderDialog(new LoaderLandscapeProperties(), new LoaderPortraitProperties(), version);
        return loader;
    }
    createOrientation() {
        return null;
    }
    /*        public createFontMap(): FontMap {
                return new FontMapLandscape();
            }*/
    createGame() {
        return new Game(this);
    }
    createMain() {
        return new Main(this);
    }
    createFreeSpinsRainbowOverlay() {
        return new FreeSpinsRainbowOverlay(this, new FreeSpinsRainbowOverlayLandscapeProperties(), new FreeSpinsRainbowOverlayPortraitProperties());
    }
    createFeatureGreenFish() {
        return new FeatureGreenFish(this, new FeatureGreenFishLandscapeProperties(), new FeatureGreenFishPortraitProperties());
    }
    createFeatureRedFish() {
        return new FeatureRedFish(this, new FeatureRedFishLandscapeProperties(), new FeatureRedFishPortraitProperties());
    }
    createFeaturePurpleFish() {
        return new FeaturePurpleFish(this, new FeaturePurpleFishLandscapeProperties(), new FeaturePurpleFishPortraitProperties());
    }
    createFeatureFishFood() {
        return new FeatureFishFood(this, new FeatureFishFoodLandscapeProperties(), new FeatureFishFoodPortraitProperties());
    }
    createFeatureGoldFish() {
        return new FeatureGoldFish(this, new FeatureGoldFishLandscapeProperties(), new FeatureGoldFishPortraitProperties());
    }
    createFeatureSelector() {
        return new FeatureSelector(this, new FeatureSelectorLandscapeProperties(), new FeatureSelectorPortraitProperties());
    }
    createFreeSpinsCounter() {
        return new GameFreeSpinsCounter(this, new FreeSpinsCounterLandscapeProperties(), new FreeSpinsCounterPortraitProperties());
    }
    createFeatureIntro() {
        return new FeatureIntro(this, new FeatureIntroLandscapeProperties(), new FeatureIntroPortraitProperties());
    }
    createBigWin() {
        return new GameBigWin(this, new BigWinLandscapeProperties(), new BigWinPortraitProperties());
    }
    createFullHouse() {
        return new GameFullHouse(this, new FullHouseLandscapeProperties(), new FullHousePortraitProperties());
    }
    createScatterWin() {
        return new GameScatterWin(this, new ScatterWinLandscapeProperties(), new ScatterWinPortraitProperties());
    }
    createCoinWinOverlay() {
        return new GameCoinWinOverlay(this, new CoinWinOverlayLandscapeProperties(), new CoinWinOverlayPortraitProperties());
    }
    createReel() {
        return new GameReel(this, new ReelLandscapeProperties());
    }
    createReels() {
        return new GameReels(this, new ReelsLandscapeProperties(), new ReelsPortraitProperties());
    }
    createTicket() {
        return new GameTicket(this, new TicketLandscapeProperties(), new TicketPortraitProperties());
    }
    createTicketSymbol() {
        return new GameTicketSymbol(this, new TicketSymbolLandscapeProperties());
    }
    createControlPanel() {
        return new GameControlPanel(this, new ControlPanelLandscapeProperties(), new ControlPanelPortraitProperties());
    }
    createOptions() {
        return new Options(this, new OptionsLandscapeProperties(), new OptionsPortraitProperties());
    }
    createBonusHelp() {
        return new BonusHelp(new BonusHelpLandscapeProperties(), new BonusHelpPortraitProperties(), () => {
            const helpClose = document.querySelector("#help .close");
            helpClose.disabled = true;
            this.model.dispatch(CommonGameEvent.HELP_DIALOG_OPEN);
            this.model.dispatch(CommonGameEvent.HELP_OPEN);
            gsap.delayedCall(0.1, () => helpClose.disabled = false);
        });
    }
    createArcadeWheel() {
        return new GameArcardWheel(this, new ArcadeWheelLandscapeProperties(), new ArcadeWheelPortraitProperties());
    }
    createStakeSelector() {
        return new GameStakeSelector(new StakeSelectorLandscapeProperties(), new StakeSelectorPortraitProperties());
    }
    createSpinsRemaining() {
        return new GameSpinsRemaining(this, new SpinsRemainingLandscapeProperties(), new SpinsRemainingPortraitProperties());
    }
    createBackground() {
        return null;
    }
    createPayTable() {
        return new GamePayTable(this, new PayTableLandscapeProperties(), new PayTablePortraitProperties());
    }
    createPayTableCell(properties) {
        return new GamePayTableCell(this, properties);
    }
    createPortraitPayTable() {
        return new GameMiniPayTable(this, new MiniPayTablePortraitProperties());
    }
    createWinDisplay() {
        return new GameWinDisplay(this, new WinDisplayLandscapeProperties(), new WinDisplayPortraitProperties());
    }
    createAvailableWinDisplay() {
        return new GameAvailableWinDisplay(this, new AvailableWinDisplayLandscapeProperties(), new AvailableWinDisplayPortraitProperties());
    }
    createNavigation() {
        return new Navigation(this, new NavigationLandscapeProperties(), new NavigationPortraitProperties());
    }
    createMessageBar() {
        return new GameMessageBar(this, new MessageBarLandscapeProperties(), new MessageBarPortraitProperties());
    }
    createMessageBarData() {
        return new GameMessageBarData();
    }
    createTestDisplay() {
        return new GameTest(this, new TestDisplayLandscapeProperties(), new TestDisplayPortraitProperties());
    }
    createSlingoAnimation() {
        return new GameSlingoAnimation(this, new SlingoAnimationLandscapeProperties(), new SlingoAnimationPortraitProperties());
    }
    createSummary() {
        return new GameSummary(this, new GameSummaryLandscapeProperties(), new GameSummaryPortraitProperties());
    }
    createSummaryCell() {
        return null;
    }
    createDemoPlay() {
        return new DemoPlay(new DemoPlayLandscapeProperties());
    }
    getDialogManager() {
        if (!this.dialogManager) {
            this.dialogManager = new GameDialogManager(new DialogManagerLandscapeProperties(), new DialogManagerPortraitProperties());
        }
        return this.dialogManager;
    }
    getModel() {
        return this.model;
    }
    createDialogController() {
        return new GameDialogController(this);
    }
    createOrientationController() {
        return new OrientationController(this);
    }
    createControllers() {
        let controllers = [];
        controllers.push(new AppController(this));
        controllers.push(new GameController(this));
        controllers.push(new SettingsController(this));
        controllers.push(new GameSoundController(this));
        controllers.push(new GameSoundClawpawtraController(this));
        controllers.push(new GameSoundTailTotesController(this));
        controllers.push(new GameSoundLiftController(this));
        controllers.push(new GameSoundLadyMeowController(this));
        controllers.push(new GameSoundHungryHenryController(this));
        controllers.push(new GameSoundJaspurrsCupsController(this));
        controllers.push(new GameReelController(this));
        controllers.push(new FreeSpinReelTransitionController(this));
        controllers.push(new FeatureTransitionController(this));
        controllers.push(new FeatureGreenFishController(this));
        controllers.push(new FeatureFishFoodController(this));
        controllers.push(new FeatureGoldFishController(this));
        controllers.push(new FeatureRedFishController(this));
        controllers.push(new FeaturePurpleFishController(this));
        controllers.push(new FeatureSelectorController(this));
        return controllers;
    }
    getOperatorConfig() {
        return this.wrapperConfig.getOperatorConfig();
    }
    setWrapperConfig(config) {
        this.wrapperConfig = config;
        if (this.wrapperConfig) {
            this.model.setGameId(this.wrapperConfig.getOperatorParameters().getGameId());
        }
    }
    getWrapperConfig() {
        return this.wrapperConfig;
    }
    getConfigPath() {
        return AppData.VERSION + "/xml/game/Config.xml";
    }
    getLandscapeTileLocation() {
        return AppData.VERSION + "/res/Game-LoaderBackground.webp";
    }
    getPortraitTileLocation() {
        return AppData.VERSION + "/res/Game-LoaderBackground.webp";
    }
    getLandscapeViewport() {
        return new Viewport(1946, 1946, 1024, 1024, OrientationType.LANDSCAPE);
    }
    getPortraitViewport() {
        return new Viewport(1024, 1024, 1946, 1946, OrientationType.PORTRAIT);
    }
    createGameConfig() {
        return new GameConfig();
    }
    createGameHistory() {
        if (this.hasInGameReplay()) {
            return null;
        }
        return new DetailedGameHistory(this, new DetailedGameHistoryPropertiesLandscape(), new DetailedGameHistoryPropertiesPortrait());
    }
    createGameMainTransition() {
        return new GameMainTransition(this, new GameMainTransitionLandscapeProperties(), new GameMainTransitionPortraitProperties());
    }
    getGameConfig() {
        return new GameConfig();
    }
    setGameConfig(gameConfig) { }
    //////////////////////////////////////////////////////////////////////////////////////
    createGameBackground() {
        return new GameBackground(this, new GameBackgroundLandscapeProperties(), new GameBackgroundPortraitProperties());
    }
    createFreeSpinsOverlay() {
        return new GameFreeSpinsOverlay(this, new FreeSpinsOverlayLandscapeProperties(), new FreeSpinsOverlayPortraitProperties());
    }
    createSignPosting() {
        return new SGDSignposting("Slingo Irishxxxtreme", new SGDSignpostingLandscapeProperties(), new SGDSignpostingPortraitProperties());
    }
    getFreeRoundsUIProperties() {
        return new AbstractFreeRoundsInfoBannerProperties(new PIXI.Point(), FreeRoundsInfoBannerLocation.BOTTOM);
    }
    hasInGameReplay() {
        return this.getWrapperConfig().getGame().getHasReplay() === "true";
    }
    hasAccessibleHelp() {
        return false;
    }
}
